import { useIntl } from 'react-intl';
import { Alert, Button, Stack, Typography } from '@rossum/ui/material';
import { boldText } from '../../../../../lib/formaterValues';

type TryAutomationAssistantBannerProps = {
  onClick: () => void;
};

export const TryAutomationAssistantBanner = ({
  onClick,
}: TryAutomationAssistantBannerProps) => {
  const intl = useIntl();

  return (
    <Alert severity="info">
      <Stack spacing={1} useFlexGap>
        <Typography variant="subtitle2">
          {intl.formatMessage({
            id: 'containers.settings.queues.queue.automation.optimization.tryAutomationAssistantBanner.title',
          })}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {intl.formatMessage(
            {
              id: 'containers.settings.queues.queue.automation.optimization.tryAutomationAssistantBanner.description',
            },
            { boldText }
          )}
        </Typography>
        <Button
          variant="outlined"
          color="secondary"
          sx={{ alignSelf: 'flex-start' }}
          onClick={onClick}
        >
          {intl.formatMessage({
            id: 'containers.settings.queues.queue.automation.optimization.tryAutomationAssistantBanner.button',
          })}
        </Button>
      </Stack>
    </Alert>
  );
};
